var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loaders-eiei"},[_c('div',{staticClass:"loader-eiei"},[_c('div',{staticClass:"skeleton-group-eiei"},[_c('div',{staticClass:"skeleton-eiei block"})])])])
}]

export { render, staticRenderFns }